import React, { Component } from 'react';
import AppUtils from '../../apputils';
import axios from 'axios';
import { AddUser, SocialLogin } from '../../models/users';

import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import SignupPage from './signup';

//import $ from 'jquery';

class signUpContainer extends Component {
  constructor() {
    super()
    this.state = {
      txtSignupFirstName: '',
      txtSignupLastName: '',
      txtSignupUserMobileCode: '+91',
      txtSignupUserMobile: '',
      txtSignupEmail: '',
      txtSignupPassword: '',
      txtSignupValidationMessage: '',
      txtFacebookSignupEmail: '',
      txtSignupAge: '',
      signupUser: false,
      sociallogin: false
    }
    this.signupdata = {}
    this.socialloginData = {}
  }

  HandleRouting = (route) => {
    AppUtils.HandlePageClick(this.props.componentprops, route)
  }

  componentDidMount = () => {
    //alert(this.props.componentprops.match.params.referral)
    if (this.props.componentprops.match.params.referral !== '' && this.props.componentprops.match.params.referral !== undefined && this.props.componentprops.match.params.referral !== null) {
      var reffered_code = this.props.componentprops.match.params.referral
      var code = reffered_code.slice(reffered_code.indexOf('=') + 1)
      sessionStorage.setItem('referred_code', code)
    }
  }

  HandleUserMobile = () => {
    this.setState({
      txtSignupUserMobile: '+91'
    })
  }

  CheckSignUp = (e) => {
    if (e.keyCode === 13) {
      // alert('13')
      this.Signup();
    }

  }
  HandleSignupInputs = (e) => {

    if (this.state.txtSignupValidationMessage !== '') {
      this.setState({
        txtSignupValidationMessage: ''
      })
    }
    const val = e.target.value;
    const name = e.target.name;
    this.setState({ [name]: val });
    if (name === "txtSignupEmail") this.txtSignupEmail = val;
    else if (name === "txtSignupPassword") this.txtSignupPassword = val;
    else if (name === 'txtSignupAge') {
      this.HandleDateTime();
    }

  }

  HandleDateTime = () => {
    // alert( new Date().getFullYear() - 55)
    let finaldatetime = '';

    let config = {
      // day: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      // shortDay: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      // MDW: 'D, MM-d',
      // YM: 'yyyy-M',
      OK: 'OK',
      CANCEL: 'CANCEL',
      CLEAR: 'CLEAR'
    }
    var DateTimePicker = require('date-time-picker')
    let that = this;


    let maxAge = new Date().getFullYear() - 55;
    let maxMonth = new Date().getMonth() + 1;
    if (maxMonth < 10) {
      maxMonth = '0' + maxMonth;
    }
    // alert(maxMonth)
    let maxDate = new Date().getDate();
    if (maxDate < 10) {
      maxDate = '0' + maxDate;
    }
    //  alert(maxDate)
    maxAge = maxAge + '-' + maxMonth + '-' + maxDate;
    //alert(maxAge)

    let options = {
      lang: 'EN', // default 'EN'. One of 'EN', 'zh-CN'
      format: 'yyyy-MM-dd', // default 'yyyy-MM-dd'
      // default: '2016-10-19', // default `new Date()`. If `default` type is string, then it will be parsed to `Date` instance by `format` . Or it can be a `Date` instance
      //  min: '2017-01-01', // min date value, `{String | Date}`, default `new Date(1900, 0, 1, 0, 0, 0, 0)`
      max: maxAge // max date value, `{String | Date}`, default `new Date(2100, 11, 31, 23, 59, 59, 999)`
    }

    var datePicker = new DateTimePicker.Date(options, config)
    datePicker.on('selected', function (formatDate, now) {
      // alert('hii'+formatDate)
      // formatData = 2016-10-19
      // now = Date instance -> Wed Oct 19 2016 20:28:12 GMT+0800 (CST)
      finaldatetime = formatDate;
      that.setState({
        txtSignupAge: finaldatetime
      })

    })
    datePicker.on('cleared', function () {
      // clicked clear btn
      finaldatetime = finaldatetime;
      that.setState({
        txtSignupAge: finaldatetime
      })
    })
  }

  Signup = () => {
    const emailExpn = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (this.state.txtSignupFirstName === '' || this.state.txtSignupFirstName.length < 2) {
      this.setState({
        txtSignupValidationMessage: 'Enter Valid Name'
      })
      return false
    }
    else {
      this.setState({
        txtSignupValidationMessage: ''
      })
    }
    // if (this.state.txtSignupLastName === '' || this.state.txtSignupLastName.length < 2) {
    //   this.setState({
    //     txtSignupValidationMessage: 'Enter Valid Name'
    //   })
    //   return false
    // }
    // else {
    //   this.setState({
    //     txtSignupValidationMessage: ''
    //   })
    // }
    if (this.state.txtSignupAge === '') {
      this.setState({
        txtSignupValidationMessage: 'Enter Your Date of Birth'
      })
      return false
    }
    else {
      this.setState({
        txtSignupValidationMessage: ''
      })
    }
    if (this.state.txtSignupEmail === '' || emailExpn.test(this.state.txtSignupEmail) !== true) {
      this.setState({
        txtSignupValidationMessage: 'Enter Valid Email'
      })
      return false
    }
    else {
      this.setState({
        txtSignupValidationMessage: ''
      })
    }
    if (this.state.txtSignupPassword === '') {
      this.setState({
        txtSignupValidationMessage: 'Please Enter your password'
      })
      return false
    }
    else {
      this.setState({
        txtSignupValidationMessage: ''
      })
    }
    if (this.state.txtSignupValidationMessage === '') {
      this.signupdata = {
        txtSignupEmail: this.state.txtSignupEmail,
        txtSignupFirstName: this.state.txtSignupFirstName,
        txtSignupLastName: this.state.txtSignupLastName,
        txtSignupAge: this.state.txtSignupAge,
        txtSignupUserMobile: this.state.txtSignupUserMobileCode + this.state.txtSignupUserMobile,
        txtSignupPassword: this.state.txtSignupPassword,
        referred_by: sessionStorage.getItem('referred_code')
      }

      console.log(this.signupdata)

      this.setState({ signupUser: true })
    }
  }

  responseSuccessGoogle = (response) => {
    // console.log(response);
    this.socialloginData = {
      email: response.profileObj.email,
      name: response.profileObj.name,
      googleId: response.profileObj.googleId,
      referred_by: sessionStorage.getItem('referred_code')
    }

    console.log(this.socialloginData);


    this.setState({ sociallogin: true })


    // console.log(data);
  }

  responseFailureGoogle = (resp) => {
    console.log(resp);
  }

  responseSuccessFacebook = (response) => {
    // axios({
    //   method: 'GET',
    //   url: `https://graph.facebook.com/v2.11/${response.userID}/?fields=id,name,email&access_token=${response.accessToken}`
    // }).then(res => {
    //   // this.setState({
    //   //     txtFacebookLoginEmail: res.data.email
    //   // })
    //   console.log(res.data)
    //  this.setState({
    //    facebookEmail:res.data.email
    //  })

    // })
    //  console.log(this.state.facebookEmail);
    console.log(response)
    this.socialloginData = {
      email: response.email,
      name: response.name,
      googleId: response.id,
      referred_by: sessionStorage.getItem('referred_code')
    }
    this.setState({
      sociallogin: true
    })
    //  console.log(',,,' + JSON.stringify(this.socialloginData))


  }

  PushNotification = (externalUserId) => {
    var data = JSON.stringify({
      "app_id": "b73b1d9d-2e6e-43fe-81e1-b9ab31caba87",
      //   "included_segments": [
      //     "Subscribed Users"
      //   ],
      "channel_for_external_user_ids": "push",
      "include_external_user_ids": [externalUserId],
      "data": {
        "foo": "bar"
      },
      "name": "Event",
      "contents": {
        "en": `Kinship welcomes you, Please login to explore the sessions`
      },

      "url": "https://www.kinshipliving.com/upcoming-sessions",


    });

    var config = {
      method: 'post',
      url: 'https://onesignal.com/api/v1/notifications',
      headers: {
        'Authorization': 'Basic YWJmOTYyNDktODE0NC00Y2FjLWE2NTItODQxZmVhNThhNGNl',
        'Content-Type': 'application/json'
      },
      data: data
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
      })
      .catch(function (error) {
        console.log(error);
      });

  }

  HandleSignupDataSuccessResponse = (res) => {
    if (res !== false) {
      console.log(JSON.stringify(res))
      document.getElementById('spnSuccessMessageTitle').innerText = "Login Response - ";
      document.getElementById('spnSuccessMessage').innerText = res.data.usersignupresponse.message.value;

      let id = res.data.usersignupresponse.message.value;

      let _id = id.slice(id.indexOf('-')+1 , id.length);

    
      
     var OneSignal = OneSignal || [];

      window.OneSignal = window.OneSignal || [];
      window.OneSignal.push(function () {
       //    alert(externalUserId)
           window.OneSignal.setExternalUserId(_id);
      });

     this.PushNotification(_id);

      let that = this;
      // $('#crmSuccessAlert').slideDown().slideUp(3000, function () {
         AppUtils.HandlePageClick(that.props.componentprops, 'login');
      // })
    }
    else {
      // document.getElementById('spnWarningMessageTitle').innerText = "Login Response - ";
      // document.getElementById('spnWarningMessage').innerText = this.props.PnkStore.GetData('error').prettyMessage;
      // let that = this;
      // $('#crmWarningAlert').slideDown().slideUp(3000, function () {
      // })
      this.setState({
        txtSignupValidationMessage: this.props.PnkStore.GetData('error').prettyMessage
      })
    }
    this.setState({ signupUser: false });
  }

  HandleSocialLoginDataSuccessResponse = (res) => {
    if (res !== false) {
      let d = new Date();
      d.setMinutes(d.getMinutes() + 240);
      if (res.data.userloginresponse.rows.length > 0) {
        if (res.data.userloginresponse.rows[0].user_email === 'finelogics.prabhash@gmail.com')
          d.setMinutes(d.getMinutes() + 24000);
        localStorage.setItem('current_user_id', res.data.userloginresponse.rows[0]._id);
        localStorage.setItem('current_user_email', res.data.userloginresponse.rows[0].user_email);
        localStorage.setItem('current_user_profile', res.data.userloginresponse.rows[0].user_profile);
        localStorage.setItem('current_user_full_name', res.data.userloginresponse.rows[0].user_full_name);
        localStorage.setItem('current_user_login_token', res.data.userloginresponse.token);
        localStorage.setItem('login_token_expire_time', d);
      }

      let externalUserId = res.data.userloginresponse.rows[0]._id
    //  var OneSignal = OneSignal || [];
    window.OneSignal = window.OneSignal || [];
     window.OneSignal.push(function () {
      //    alert(externalUserId)
          window.OneSignal.setExternalUserId(externalUserId);
      });

   //   this.PushNotification(externalUserId);



      document.getElementById('spnSuccessMessageTitle').innerText = "Login Response - ";
      document.getElementById('spnSuccessMessage').innerText = "Successfully Logged In";
    //  let that = this;

      this.props.PnkStore.SetData('loginstatus', true)
      if (res.data.userloginresponse.rows[0].user_full_name === undefined || res.data.userloginresponse.rows[0].user_full_name === null || res.data.userloginresponse.rows[0].user_full_name === '') {
        let name = (res.data.userloginresponse.rows[0].user_email).substring(0, (res.data.userloginresponse.rows[0].user_email).indexOf("@"));
        this.props.PnkStore.SetData('loginusername', name)
        localStorage.setItem('current_user_name', name);
      }
      else {
        this.props.PnkStore.SetData('loginusername', res.data.userloginresponse.rows[0].user_full_name)
        localStorage.setItem('current_user_name', res.data.userloginresponse.rows[0].user_full_name);
      }

      this.props.PnkStore.BroadCast();

      // $('#crmSuccessAlert').slideDown().slideUp(3000, function () {
      //   AppUtils.HandlePageClick(that.props.componentprops, 'home');
      // })
    }
    else {
      // document.getElementById('spnWarningMessageTitle').innerText = "Login Response - ";
      // document.getElementById('spnWarningMessage').innerText = this.props.PnkStore.GetData('error').prettyMessage;
      // let that = this;
      // $('#crmWarningAlert').slideDown().slideUp(3000, function () {
      //     // AppUtils.HandlePageClick(that.props.componentprops, 'leads');
      // })
      this.setState({
        txtSignupValidationMessage: this.props.PnkStore.GetData('error').prettyMessage
      })

    }
    this.setState({ sociallogin: false });
  }



  render() {
    // alert(this.state.txtSignupAge)
    return (
      <div>
        {localStorage.getItem('current_user_name') == null && localStorage.getItem('current_user_login_token') == null && localStorage.getItem('current_user_profile') == null ?
          <SignupPage {...this.props} HandleRouting={this.HandleRouting} HandleSignupInputs={this.HandleSignupInputs}
            Signup={this.Signup} responseSuccessGoogle={this.responseSuccessGoogle} responseFailureGoogle={this.responseFailureGoogle}
            responseSuccessFacebook={this.responseSuccessFacebook} txtSignupFirstName={this.state.txtSignupFirstName}
            txtSignupLastName={this.state.txtSignupLastName} txtSignupUserMobile={this.state.txtSignupUserMobile}
            txtSignupEmail={this.state.txtSignupEmail} HandleUserMobile={this.HandleUserMobile} CheckSignUp={this.CheckSignUp}
            txtSignupPassword={this.state.txtSignupPassword} txtSignupValidationMessage={this.state.txtSignupValidationMessage}
            txtFacebookSignupEmail={this.state.txtFacebookSignupEmail}
            txtSignupUserMobileCode={this.state.txtSignupUserMobileCode}
            txtSignupAge={this.state.txtSignupAge}
          />
          : AppUtils.HandlePageClick(this.props.componentprops, 'home')}
        {((this.state.signupUser === true) ? AddUser(this.props.PnkStore, this.signupdata, this.HandleSignupDataSuccessResponse) : "")}
        {((this.state.sociallogin === true) ? SocialLogin(this.props.PnkStore, this.socialloginData, this.HandleSocialLoginDataSuccessResponse) : "")}
      </div>
    )
  }
}
export const SignUpContainer = PnkConnect(signUpContainer, '');